import React, { useEffect } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import GroupIcon from '@mui/icons-material/Group';
import { UserItem } from './components/UserItem';
import { Loading } from '../../shared/components/Loading';
import { User, useUsersLazyQuery } from '../../shared/types/generated';
import { UserChangeStatusDialog } from './components/UserChangeStatusDialog';
import { DeleteUserDialog } from './components/DeleteUserDialog';

export const Users: React.FC = () => {

  const [callUsers, { loading, data }] = useUsersLazyQuery();

  useEffect(() => {
    callUsers();
  }, [callUsers]);

  const users = (data?.users?.items || []) as User[];

  return (
    <Box>
      <Box display={'flex'}>
        <GroupIcon fontSize='medium' />
        <Typography fontWeight={600} paddingLeft={'10px'}>
          Users
        </Typography>
      </Box>
      <Box style={{ overflow: 'auto' }}>
        <Box
          my={'15px'}
          border={'1px solid #F1F1F1'}
          borderRadius={'10px'}
          style={{ background: 'white', minWidth: 1200 }}
        >
          <Grid py={'5px'} px={'15px'} container>
            <Grid
              container
              py={'5px'}
              style={{ background: '#F8F8F8' }}
              borderBottom={'1px solid #F0F0F0'}

            >
              <Grid item xs={2}>
                <Typography fontWeight={600} textAlign={'center'}>Broker ID</Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography fontWeight={600} textAlign={'center'}>
                  Email
                </Typography>
              </Grid>
              <Grid item xs={1}>
                <Typography fontWeight={600} textAlign={'center'}>
                  Role
                </Typography>
              </Grid>
              <Grid item xs={1}>
                <Typography fontWeight={600} textAlign={'center'}>
                  Balance
                </Typography>
              </Grid>
              <Grid item xs={1}>
                <Typography fontWeight={600} textAlign={'center'}>
                  Profit
                </Typography>
              </Grid>
              <Grid item xs={1}>
                <Typography fontWeight={600} textAlign={'center'}>
                  Created at
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography fontWeight={600} textAlign={'center'}>
                  Suspended at
                </Typography>
              </Grid>

              <Grid item xs={1}>
                <Typography fontWeight={600} textAlign={'center'}>
                  Status
                </Typography>
              </Grid>
              <Grid item xs={1}>
                <Typography fontWeight={600} textAlign={'center'}>
                  Actions
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          {loading ? (
            <Loading height='350px' />
          ) : (
            users.map((user) => <UserItem item={user} />)
          )}
        </Box>
      </Box>
      <UserChangeStatusDialog onSuccess={() => callUsers()} />
      <DeleteUserDialog onSuccess={() => callUsers()} />
    </Box>
  );
};
